export default class OrderShippingLabel {

  static TYPE_OUTGOING = 1;
  static TYPE_RETURN = 2;

  static STATUS_NEW = 1;
  static STATUS_CREATED = 2;
  static STATUS_CANCEL = 3;
  static STATUS_USED = 4;

  static PICKUP_OPTION_NO = 0;
  static PICKUP_OPTION_YOUR_LOCATION = 1;
  static PICKUP_OPTION_DROPOFF_FEDEX_LOCATION = 2;
  static PICKUP_OPTION_MAV_SCHEDULED = 3;

  static CARRIER_OTHER = 1;
  static CARRIER_FEDEX = 2;
  static CARRIER_UPS = 3;

  static getShippingCompanyMap() {
    return {
      [this.CARRIER_FEDEX]: 'FedEx',
      [this.CARRIER_UPS]: 'UPS',
      [this.CARRIER_OTHER]: 'Other'
    };
  }

  static getGenerateLabelPickupMap() {
    return {
      [this.PICKUP_OPTION_NO]: 'No',
      [this.PICKUP_OPTION_YOUR_LOCATION]: 'Scheduled Pickup at Your Location',
      [this.PICKUP_OPTION_DROPOFF_FEDEX_LOCATION]: 'Drop-off at a FedEx Location ',
      [this.PICKUP_OPTION_MAV_SCHEDULED]: 'Mavsign Scheduled Pickup',
    };
  }

  static getShippingCompanyName(id) {
    return this.getShippingCompanyMap()[id];
  }

  static getTypeMap() {
    return {
      [this.TYPE_OUTGOING]: 'Outgoing Label',
      [this.TYPE_RETURN]: 'Return Label',
    };
  }

  static getGenerateLabelDocumentsPickup() {
    return {
      [this.PICKUP_OPTION_YOUR_LOCATION]: {
        firstText: 'Scheduled Pickup at Your Location',
        secondText: "If you've already arranged a pickup, no further action is needed"
      },
      [this.PICKUP_OPTION_DROPOFF_FEDEX_LOCATION]: {
        firstText: 'Drop-off at a FedEx Location',
        secondText: 'You will personally drop off your package at a nearby FedEx center.'
      },
      [this.PICKUP_OPTION_MAV_SCHEDULED]: {
        firstText: 'Mavsign Scheduled Pickup',
        secondText: 'Mavsign can arrange a pickup for you, though additional fees may be applied. Please prepare the docs for pickup within the next 36 hours.'
      }
    }
  }

  static getFedexPackagingTypes() {
    return {
      "FEDEX_ENVELOPE": "FedEx® Envelope",
    }
  }
}